let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7BI7e")).then(() => parcelRequire('hFG4c'));